import React from 'react';
//import SwitchLayout from './layout/SwitchLayout'
import Layout from './layout/Layout'
import './App.css';

import { BrowserRouter } from 'react-router-dom';
import AlertaState from './context/alertas/alertaState';
import AuthState from './context/autentication/authState';
import PageState from './context/page/pageState';
import PaisState from './context/pais/paisState';
import ProvinciaState from './context/provincia/provinciaState';
import LocalidadState from './context/localidad/localidadState';
import ClienteState from './context/cliente/clienteState';
import UsuarioState from './context/usuario/usuarioState';
import GrupoState from './context/grupo/grupoState';
import SubGrupoState from './context/subgrupo/subgrupoState';
import DispositivoState from './context/dispositivo/dispositivoState';
import VariableState from './context/variable/variableState';
import RegistroState from './context/registro/registroState';
import MarcaContext from "./context/marca/marcaState"
import ModeloContext from "./context/modelo/modeloState"
import LoRaContext from "./context/LoRa/loraState"
import WidgetState from './context/widget/widgetState';
import tokenAuth from './service/token';
import DownlinkState from './context/downlink/downlinkState'
import IsMobileState from './context/isMobile/isMobileState';
import DeviceProfileState from './context/deviceProfile/deviceProfileState'
import ValidationsState from './context/validations/validationsState';
import ServiceProfileState from './context/serviceProfile/serviceProfileState'
import ApplicationSate from "./context/application/applicationState"
import StatisticState from 'context/statistic/statisticState';
import DashboardState from 'context/dashboard/dashboardState';
import HistoricoState from 'context/historico/historicoState';
import { IconContext } from "react-icons";
import LegalesState from 'context/legales/legalesState';
import VariableModeloState from "./context/variableModelo/variableModeloState"
import AlertasDispositivoState from 'context/alertas-dispositivo/alertasDispositivoState'
import DialogBaseProvider from 'context/dialogBaseContext/dialogBaseProvider';

// Revisar si tenemos un token
const token = localStorage.getItem('token');
if (token) {
  tokenAuth(token);
}

function App() {
  return (
    <IconContext.Provider value={{ color: "#666", className: "global-class-name", size: "24px" }}>
      <LegalesState>
        <IsMobileState>
          <AuthState>
            <ValidationsState>
              <AlertasDispositivoState>
                <ApplicationSate>
                  <ServiceProfileState>
                    <DeviceProfileState>
                      <DownlinkState>
                        <AlertaState>
                          <MarcaContext>
                            <LoRaContext>
                              <ModeloContext>
                                <PageState>
                                  <PaisState>
                                    <ProvinciaState>
                                      <LocalidadState>
                                        <ClienteState>
                                          <UsuarioState>
                                            <GrupoState>
                                              <SubGrupoState>
                                                <DispositivoState>
                                                  <VariableState>
                                                    <WidgetState>
                                                      <RegistroState>
                                                        <DashboardState>
                                                          <HistoricoState>
                                                            <StatisticState>
                                                              <VariableModeloState>
                                                                <BrowserRouter>
                                                                <DialogBaseProvider>
                                                                  <Layout />
                                                                </DialogBaseProvider>
                                                                </BrowserRouter>
                                                              </VariableModeloState>
                                                            </StatisticState>
                                                          </HistoricoState>
                                                        </DashboardState>
                                                      </RegistroState>
                                                    </WidgetState>
                                                  </VariableState>
                                                </DispositivoState>
                                              </SubGrupoState>
                                            </GrupoState>
                                          </UsuarioState>
                                        </ClienteState>
                                      </LocalidadState>
                                    </ProvinciaState>
                                  </PaisState>
                                </PageState>
                              </ModeloContext>
                            </LoRaContext>
                          </MarcaContext>
                        </AlertaState>
                      </DownlinkState>
                    </DeviceProfileState>
                  </ServiceProfileState>
                </ApplicationSate>
              </AlertasDispositivoState>
            </ValidationsState>
          </AuthState>
        </IsMobileState>
      </LegalesState>
    </IconContext.Provider>
  );
}

export default App;
